import { render, staticRenderFns } from "./ud-detail.vue?vue&type=template&id=96d2f5ae&scoped=true&"
import script from "./ud-detail.vue?vue&type=script&lang=ts&"
export * from "./ud-detail.vue?vue&type=script&lang=ts&"
import style0 from "./ud-detail.vue?vue&type=style&index=0&id=96d2f5ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d2f5ae",
  null
  
)

export default component.exports